<template>
  <div>
    <header>
      单位名称：
      <el-input
        v-model="searchKey"
        placeholder="请输入单位名称"
        style="width: 340px"
      ></el-input>状态：
      <el-select
        v-model="status"
        placeholder="请选择"
      >
        <el-option
          label="全部"
          :value="-1"
        ></el-option>
        <el-option
          label="有效"
          :value="1"
        ></el-option>
        <el-option
          label="无效"
          :value="2"
        ></el-option>
      </el-select>
      <el-button
        type="primary"
        icon="el-icon-search"
        style="margin-left: 10px"
        @click="handlerSearch"
      >查询</el-button>
      <el-button
        type="primary"
        @click="open('add')"
      >新增</el-button>
    </header>
    <el-table
      :data="tableData"
      border
      style="width: 100%; margin-top: 20px"
    >
      <el-table-column
        type="index"
        label="序号"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="contractorName"
        label="分包单位名称"
        width="180"
      ></el-table-column>
      <el-table-column
        prop="contractorTypeText"
        label="分包单位类型"
        align="center"
      >
        <!-- <template slot-scope="scope">{{ scope.row.contractorType == 1 ? '劳务分包单位' : '材料供货商' }}</template> -->
      </el-table-column>
      <el-table-column
        prop="contact"
        label="联系人"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="phone"
        label="联系方式"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="contractorCode"
        label="企业编码"
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        label="授权模块"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="getProjectModules(scope.row)"
          >配置模块</el-button>
        </template>
      </el-table-column> -->
      <el-table-column
        label="状态"
        align="center"
      >
        <template slot-scope="scope">{{ scope.row.status == 1 ? '有效' : '无效' }}</template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="open(scope.row)"
          >编辑</el-button>
          <el-button
            type="text"
            @click="handleClick(scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="tc"
      style="margin-top:20px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50]"
        :page-size="pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog
      :title="trainForm.id ? '编辑' : '新增'"
      :visible.sync="addDialogVisible"
      width="40%"
      center
      :close-on-click-modal="false"
      @close="dialogCloseFun"
    >
      <el-form
        ref="ruleForm"
        :model="trainForm"
        label-width="160px"
        :rules="rules"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="单位名称:"
              prop="contractorName"
            >
              <el-input v-model="trainForm.contractorName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="单位类型:"
              prop="contractorType"
            >
              <el-select
                v-model="trainForm.contractorType"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in unitTypeList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="联系人:"
              prop="contact"
            >
              <el-input v-model="trainForm.contact"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="联系方式:"
              prop="phone"
            >
              <el-input v-model="trainForm.phone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="企业编码:"
              prop="contractorCode"
            >
              <el-input v-model="trainForm.contractorCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="有效状态:"
              prop="status"
            >
              <el-radio
                v-model="trainForm.status"
                :label="1"
              >有效</el-radio>
              <el-radio
                v-model="trainForm.status"
                :label="2"
              >无效</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button
            type="primary"
            @click="submitForm('ruleForm')"
          >确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <authorization
      :isShow="authorizationShow"
      @isShow='closeAuthor'
    />-->
    <newAuthorization
      ref="authorization"
      :treeMenus="treeMenus"
      @selectModules="selectModules"
      :propsKey="propsKey"
      name="groupName"
    />
  </div>
</template>

<script>
import {
  provinceAndCityData
} from 'element-china-area-data'
import newAuthorization from "@/components/newAuthorization.vue";
import {
  Api_unit,
  Api_System,
  Api_SuperAdmin,
  Api_Base
} from '@/api/api'
import { getStore } from '@/util/store'
import mixin_dialog from '@/mixins/dialog.js';
import { validatorPassword } from '@/util/validateRules.js';
export default {
  components: {
    newAuthorization
  },
  mixins: [mixin_dialog],
  data() {
    return {
      treeMenus: [],
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      status: -1,
      authorizationShow: false,
      unitTypeList: [{
        name: '请选择',
        value: ''
      }],
      tableData: [],
      addDialogVisible: false,
      trainForm: {
        id: 0,
        contractorName: "",
        contractorType: '',
        contact: "",
        phone: "",
        contractorCode: '',
        status: 1
      },
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      rules: {
        // {
        //   min: 3,
        //   max: 5,
        //   message: "长度在 3 到 5 个字符",
        //   trigger: "blur",
        // },

        contractorName: [{
          required: true,
          message: "请输入单位名称",
          trigger: "blur",
        }],
        contractorType: [{
          required: true,
          message: "请输入单位类型",
          trigger: "blur",
        }],
        status: [{
          required: true,
          message: "请输入有效状态",
          trigger: "blur",
        }],
        phone: [
          {
            validator: (rule, value, callback) => {
              if (value && !/^\d{1,20}$/.test(value)) {
                callback(new Error("联系电话必须为不超过20位的数字"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        contractorCode: [
          {
            validator: (rule, value, callback) => {
              if (value && !/^[A-Za-z0-9]{1,30}$/.test(value)) {
                callback(new Error("企业编码只能是字母或数字且不超过30位"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ]
      },
      // unitId: '',
      projectId: getStore({ name: 'projectId' }),
      propsKey: [],
      haveID: '',
      itemId: '',
      companyId: getStore({ name: 'companyId' }),
      loginUser: getStore({ name: 'account' })
    };
  },
  created() {
    this.getUnitType()
    this.handlerSearch()
  },
  methods: {
    // 获取所有配置列表
    getProjectModules(val) {
      this.itemId = val.id
      let params = {
        projectId: 0
      }
      Api_Base.getProjectMenus(params).then(res => {
        const result = res.data
        let data = result.data
        if (result.statusCode && result.data) {
          data.forEach(el => {
            el.listTreeMenus.forEach(ell => {
              // ell.id = ell.menuId
              ell.groupName = ell.menuName
            })
          });
          this.treeMenus = data
          this.getProjectSelect(val.id)
        } else {
          this.$message({
            type: "error",
            message: "此公司未设置权限!",
          });
        }
      })
    },
    // 选中的配置数据
    getProjectSelect(id) {
      Api_unit.getUnitSubSelect(id).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          // if (result.data.authorityMenuId) {
          //   this.propsKey = result.data.authorityMenuId.split(',')
          // } else {
          //   this.propsKey = []
          // }
          this.propsKey = (result.data && result.data.authorityMenuId && result.data.authorityMenuId.split(',')) || []
          this.authorizationShow = true;
          this.$refs.authorization.open()
        } else {
          this.propsKey = []
          this.$showMessage("失败", result.errors);
        }

      })
    },
    // 添加配置
    selectModules(modules) {

      Api_unit.setUnitModules({
        authorityCompanyId: this.companyId,
        authorityProjectId: this.projectId,
        authorityUintId: this.itemId,
        authorityMenuId: modules.join(',')
      }).then(res => {
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        this.authorizationShow = false
      })
    },
    open(val) {
      if (val !== 'add') {
        console.log(val)
        // this.trainForm.id = val.id
        // Api_unit.detail(val.id).then(res => {
        //   this.trainForm = res.data.data
        // })
        this.trainForm = {
          id: val.id,
          contractorName: val.contractorName,
          contractorType: val.contractorType,
          contact: val.contact,
          phone: val.phone,
          contractorCode: val.contractorCode,
          status: val.status
        }
      } else {
        // this.resetForm()
        this.trainForm = {
          id: 0,
          contractorName: "",
          contractorType: '',
          contact: "",
          phone: "",
          contractorCode: "",
          status: 1
        }
      }
      this.addDialogVisible = true
    },
    closeAuthor(val) {
      this.authorizationShow = val
      this.propsKey = []
      this.companyId = ''
      this.haveID = ''
    },
    handleClick(val) {
      this.$confirm('是否删除此单位?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_unit.delContractor(val.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handleChange(value) {
      console.log(value)
    },
    getUnitType() {
      this.unitTypeList = [{
        name: '请选择',
        value: ''
      }, { name: '劳务分包单位', value: 1 }, { name: '材料供货商', value: 2 }]
      // Api_System.getUnitType().then(res => {
      //   const result = res.data
      //   if (result.statusCode == 200) {
      //     result.data.map(t => {
      //       this.unitTypeList.push({
      //         name: t.typeName,
      //         value: t.id
      //       })
      //     })
      //   }
      // })
    },
    handlerSearch() {
      let params = {
        projectId: this.projectId,
        contractorName: this.searchKey,
        // contractorType: 0, // 全部
        status: this.status,
        pageSize: this.pagesize,
        pageIndex: this.currentPage
      }
      Api_unit.getContractorList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.tableData = result.data.items
          this.totalCount = result.data.totalCount
        }
      })
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    addUnit() {

      Api_unit.addContractor(this.trainForm).then(res => {
        this.addDialogVisible = false
        const result = res.data
        if (result.statusCode) {
          this.handlerSearch()
        }
      })
    },
    editUnit() {
      // TODO 编辑需要后台添加查看详情的接口
      Api_unit.editContractor(this.trainForm).then(res => {
        this.addDialogVisible = false
        const result = res.data
        if (result.statusCode) {
          this.handlerSearch()
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.trainForm.id) {
            this.editUnit()
          } else {
            this.addUnit()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.addDialogVisible = false
      // this.trainForm = {}
      this.trainForm.id = ''
      this.$refs[formName].resetFields();
    },
    openConstractor() {
      this.$refs.constractor.open()
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-radio__label {
  color: #fff !important;
}
</style>